module.exports = __webpack_public_path__ + "img/icon_message_over.d63d351d.svg";